import {faBox} from "@fortawesome/pro-solid-svg-icons/faBox";
import {faCheckCircle} from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import {faEnvelope} from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import {faLocationCrosshairs} from "@fortawesome/pro-solid-svg-icons/faLocationCrosshairs";
import {faNote} from "@fortawesome/pro-solid-svg-icons/faNote";
import {faRuler} from "@fortawesome/pro-solid-svg-icons/faRuler";
import {faSearch} from "@fortawesome/pro-solid-svg-icons/faSearch";
import {faTag} from "@fortawesome/pro-solid-svg-icons/faTag";
import {faTruckFast} from "@fortawesome/pro-solid-svg-icons/faTruckFast";
import {faUser} from "@fortawesome/pro-solid-svg-icons/faUser";
import {faWeightScale} from "@fortawesome/pro-solid-svg-icons/faWeightScale";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    Button,
    ButtonSize,
    ColourOutline,
    ContentBlock,
    FlexGap,
    GenericLoader,
    Padding,
    Tooltip,
    useLayout,
    useTranslation
} from "@twigsby/frontend-framework";
import React from "react";
import {NavLink, useNavigate} from "react-router-dom";
import {useMailbox} from "../../../Providers/NewMailboxProvider";
import {MailTypeEnum} from "../../../Types/MailboxProviderTypes";
import {MailItemContentType} from "../../../Types/MailItemTypes";
import {MailTagCollection} from "../../Mail/MailTagCollection";

const MailItemMeta = (props: MailItemContentType) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isMedium } = useLayout();

    const { mailItemRequiresTopUp, mailNote, UpdateMailTags, UpdateMailNote, mailItemData} = useMailbox();

    return (
        <div
            className={'sticky'}
            style={{top: `calc(${props.mailboxTopBarHeight}px + var(--md-unit))`}}
        >
            <div className={'mail-item-meta-grid'}>

                {mailItemData?.mailLocationId !== 7 && !mailItemData?.incomingRecipientName && !!mailItemData?.clientName && (
                    <ContentBlock
                        title={t('mailItem.labels.assigned')}
                        content={mailItemData?.clientName}
                        iconContent={{icon: faUser, iconSpacing: FlexGap.Small}}
                        extraClass={'icon-content'}
                        padding={Padding.ExtraSmall}
                    />
                )}

                {mailItemData?.mailLocationId !== 7 && mailItemData?.incomingRecipientName && (
                    <ContentBlock
                        title={t('mailItem.labels.assigned')}
                        content={mailItemData?.incomingRecipientName.name}
                        iconContent={{icon: faUser, iconSpacing: FlexGap.Small}}
                        extraClass={'icon-content'}
                        padding={Padding.ExtraSmall}
                        button={
                            <Tooltip content={t('mailItem.actions.nameFilter')}>
                                <Button
                                    title={t('mailItem.labels.assigned')}
                                    icon={faSearch}
                                    iconOnly={true}
                                    size={ButtonSize.Small}
                                    colour={ColourOutline.Secondary}
                                    onClick={() => mailItemData?.incomingRecipientName ? navigate('/mail/all', {
                                        state: {
                                            folderId: 8,
                                            incomingRecipientNameIds: mailItemData?.incomingRecipientName.id,
                                            incomingRecipientNameIdsFriendly: `Name: ${mailItemData?.incomingRecipientName.name}`
                                        }
                                    }) : null}
                                />
                            </Tooltip>
                        }
                    />
                )}

                {mailItemData?.mailType !== undefined && (
                    <ContentBlock
                        title={t('mailItem.labels.itemType')}
                        content={MailTypeEnum[mailItemData?.mailType]}
                        iconContent={{
                            icon: mailItemData?.mailType === 1 ? faEnvelope : faBox,
                            iconSpacing: FlexGap.Small
                        }}
                        extraClass={'icon-content'}
                        padding={Padding.ExtraSmall}
                    />
                )}

                {mailItemData?.itemSize?.width !== null && (
                    <>
                        <ContentBlock
                            title={t('mailItem.labels.dimensions')}
                            content={`${mailItemData?.itemSize?.width} ${mailItemData?.itemSize?.height !== null ? 'x ' + mailItemData?.itemSize?.height : ''}  ${mailItemData?.itemSize?.depth !== null ? 'x ' + mailItemData?.itemSize?.depth : ''} CM`}
                            iconContent={{icon: faRuler, iconSpacing: FlexGap.Small}}
                            extraClass={'icon-content'}
                            padding={Padding.ExtraSmall}
                            button={
                                <>
                                    {mailItemData?.mailLocationId !== 7 && mailItemData?.itemSize?.weight !== null && (
                                        <Tooltip content={t('mailItem.actions.shipping')}>
                                            <NavLink
                                                to={`/shipping-calculator/${mailItemData?.itemSize?.weight}/${mailItemData?.itemSize?.width}/${mailItemData?.itemSize?.height}/${mailItemData?.itemSize?.depth}`}
                                                target={'_blank'}
                                                className={'btn interactive btn-sm btn-icon-only btn-icon secondary-outline'}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faTruckFast}
                                                    fixedWidth={true}
                                                />
                                            </NavLink>
                                        </Tooltip>
                                    )}
                                </>
                            }
                        />
                    </>
                )}

                {mailItemData?.itemSize?.weight !== null && (
                    <ContentBlock
                        title={t('mailItem.labels.weight')}
                        content={`${mailItemData?.itemSize?.weight && mailItemData?.itemSize?.weight !== 0 ? mailItemData?.itemSize?.weight / 1000 + 'KG' : '0KG'}`}
                        iconContent={{icon: faWeightScale, iconSpacing: FlexGap.Small}}
                        extraClass={'icon-content'}
                        padding={Padding.ExtraSmall}
                    />
                )}

                {mailItemData?.enclosures && (
                    <ContentBlock
                        title={t('mailItem.labels.enclosures')}
                        content={mailItemData?.enclosures}
                        extraClass={'icon-content'}
                        padding={Padding.ExtraSmall}
                    />
                )}

                {mailItemData?.incomingTrackingId && (
                    <ContentBlock
                        title={t('mailItem.labels.trackingIdIn')}
                        content={mailItemData?.incomingTrackingId}
                        iconContent={{icon: faLocationCrosshairs, iconSpacing: FlexGap.Small}}

                        extraClass={'icon-content'}
                        padding={Padding.ExtraSmall}
                    />
                )}

                {mailItemData?.outgoingTrackingId && (
                    <ContentBlock
                        title={t('mailItem.labels.trackingIdOut')}
                        content={mailItemData?.outgoingTrackingId}
                        iconContent={{icon: faLocationCrosshairs, iconSpacing: FlexGap.Small}}

                        extraClass={'icon-content'}
                        padding={Padding.ExtraSmall}
                    />
                )}
            </div>

            <div className={'mail-item-meta-grid full-width-grid'}>

                {mailItemData && mailItemData?.tags?.length > 0 && (
                    <div
                        className={'flex-row   flex-gap-sm align-center justify-start  content-block   p-xs icon-content '}>
                        <FontAwesomeIcon icon={faTag} fixedWidth={true}/>
                        <div className={'flex-column   flex-gap-xs align-start    '}>
                            <div
                                className={'content-block-title'}>{t('mailItem.labels.tags')}</div>
                            <div className={'content-block-content'}>
                                <MailTagCollection tags={mailItemData?.tags}
                                                   linkSlug={'/mail/tagged/'}
                                                   hideIcon={true}
                                                   removeCallback={(tagId: number) => UpdateMailTags({value: tagId}, false)}/>
                            </div>
                        </div>
                    </div>
                )}

                <div
                    className={'flex-row flex-gap-sm align-center justify-start content-block p-xs icon-content '}>
                    <FontAwesomeIcon icon={faNote} fixedWidth={true}/>
                    <div className={'flex-column flex-gap-xs align-start'}>
                        <div
                            className={'content-block-title'}>{t('mailItem.labels.notes')}</div>
                        <div className={'content-block-content'}>
                            <div className={`inline-single-input ${mailNote.success ? 'inline-success' : ''}`}>
                                <textarea
                                    defaultValue={mailItemData?.note}
                                    rows={isMedium ? 9 : 3}
                                    readOnly={mailNote.updating || mailItemRequiresTopUp}
                                    onBlur={(e: any) =>
                                        mailItemRequiresTopUp ?
                                            null :
                                            UpdateMailNote(e.target.value, mailItemData?.note || '')
                                    }
                                />

                                {(mailNote.updating || mailNote.data) && (
                                    <div className={'overlay-loader fill-container'}>
                                        {mailNote.updating && (
                                            <GenericLoader/>
                                        )}
                                        {mailNote.success && (
                                            <FontAwesomeIcon icon={faCheckCircle} fixedWidth={true}/>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export {MailItemMeta}
